/* eslint-disable no-console */
/**
 * 驗簽
 */
import { signature } from '@/services/UserApi';
import { getRequestHeaderPlatform } from '@/utils/platform';
import { initialize, Utils } from '@gov-mo/mpaas-js-bridge';
import { useEffect } from 'react';

const useJsApi = () => {
  useEffect(() => {
    // 此處的initialize起到一個初始化環境的作用，沒有jsapi驗簽效果
    initialize({ env: ENV, platform: getRequestHeaderPlatform() } as any);
  }, []);

  /**
   * 通過 App 驗簽
   */
  const init = async () => {
    if (Utils.isGovMoApp()) {
      const config = await signature(window.location.href);
      const res = await initialize({ ...config, env: ENV, platform: getRequestHeaderPlatform() });
      console.log('🚀 ~ init ~ res:', res);
    }
  };

  return {
    init,
  };
};

export default useJsApi;
